import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  category: string;
  title: string;
  content: string
  image: string;
  slug: string;
};

export default function StoryCard({
  category,
  title,
  content: rawContent,
  image,
  slug
}: Props) {
  const navigate = useNavigate();

  const content = useMemo(() => {
    const elem = document.createElement('div')
    elem.innerHTML = rawContent

    return elem.textContent ?? ''
  }, [rawContent])

  return (
    <button
      type="button"
      onClick={() => navigate(`/success-stories/${slug}`)}
      className="group h-full w-full text-left"
    >
      <div className="flex h-full flex-col overflow-hidden rounded-xl bg-white border shadow-sm transition group-hover:shadow-md">
        {/* Image (fixed height) */}
        <div className="h-44 w-full overflow-hidden">
          <img
            src={image}
            alt={title}
            className="h-full w-full object-cover transition-transform group-hover:scale-105"
          />
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col p-6">
          {/* Top content */}
          <div>
            <span className="inline-block text-xs font-medium text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
              {category}
            </span>

            <h3 className="mt-3 text-xl font-semibold text-gray-900 leading-snug">
              {title}
            </h3>

            <p className="mt-3 text-sm text-gray-600 leading-relaxed line-clamp-3">
              {content}
            </p>
          </div>

          {/* CTA pinned to bottom */}
          <span className="mt-6 inline-block text-sm font-medium text-blue-600 group-hover:underline">
            Read Case Study →
          </span>
        </div>
      </div>
    </button>
  );
}
